<template>
  <div class="components-modifyStatus">
    <div class="header">
      将考勤修改为
    </div>
    <div class="body">
      <ul class="typeList">
        <li
          class="typeItem"
          :class="{ selected: index === selected_index, disabled: index === disabledIndex }"
          v-for="(item, index) in filteredTypeList"
          :key="index"
          @click="selectItem(item, index)"
        >
          {{ item[nameKey] }}
        </li>
      </ul>
    </div>
    <div class="footer">
      <a href="javascript:;" class="btn" @click="cancel">取消</a>
      <a
        href="javascript:;"
        class="btn primary"
        :class="{ disabled: selected_index < 0 }"
        @click="save"
        >确定</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Components_ModifyStatus',
  props: {
    nameKey: {
      required: true,
      type: String,
      default: ''
    },
    typeList: {
      required: true,
      type: Array,
      default: function() {
        return []
      }
    },
    disabledIndex: {
      required: false,
      default: -1 // 若为负数，则没有禁用项
    }
  },
  data() {
    return {
      selected_data: {},
      selected_index: -1 // 默认不做选择
    }
  },
  computed: {
    filteredTypeList() {
      return this.typeList.filter(item => item.AttCode !== 'Notyet')
    }
  },
  methods: {
    selectItem(item, index) {
      if (this.disabledIndex === index) {
        return
      }
      this.$set(this, 'selected_data', item)
      this.selected_index = index
    },
    cancel() {
      this.reset()
      this.$emit('cancel')
    },
    save() {
      if (this.selected_index < 0) {
        return
      }
      let params = this.selected_data
      this.$emit('confirm', params)
      this.reset()
    },
    reset() {
      this.selected_data = {}
      this.selected_index = -1
    }
  }
}
</script>

<style lang="less" scoped>
// 颜色方案定义
@color-primary-bg: #4196ff;
@color-primary-text: #fff;
@color-normal-bg: #e9e9e9;
@color-normal-text: #161616;
@color-disabled-text: #d2d2d2;

.components-modifyStatus {
  padding: 0;
  font-size: 30px;
  color: #333333;
}
.header {
  padding: 37px 34px 0;
}
.body {
  padding: 0 34px 110px;
}
.typeList {
  width: calc(100% + 27px); // 相当于去除此行的最后一项的右对齐空间
}
.typeItem {
  display: inline-block;
  min-width: 155px;
  line-height: 54px;
  margin: 47px 22px 0 0;
  padding: 0 1em;
  background: rgba(247, 247, 247, 1);
  border-radius: 4px;
  text-align: center;
  font-size: 26px;
  color: rgba(51, 51, 51, 1);
  &.disabled {
    color: @color-disabled-text;
  }
  &.selected {
    background-color: @color-primary-bg;
    color: @color-primary-text;
  }
}
.btn {
  display: inline-block;
  width: 50%;
  text-align: center;
  line-height: 88px;
  font-size: 28px;
  background-color: @color-normal-bg;
  color: @color-normal-text;
  &.primary {
    background-color: @color-primary-bg;
    color: @color-primary-text;
  }
  &.disabled {
    background-color: @color-normal-bg;
    color: @color-disabled-text;
  }
}
</style>
